import React, { useState } from "react";
import { ListForSign, Bar } from "../../styles/Docs/DocsToolbar.styled";
import { Btn } from "../../styles/Button.styled";
import MediaQuery from "react-responsive";
import { useAppSelector } from "../../hooks";
import { canArchiveDoc, isDocDisabled, isDocReadyToSign } from "../../helpers/docPermissions";
import DownloadButton from "../DownloadButton";
import styles from "../../styles/Spreadsheet/Spreadsheet.module.css";
// import { AlertTooltip } from "../Spreadsheet/ModTooltip";
// import { BtnWrapper } from "../../styles/Docs/DocsToolbar.styled";

import RefreshButton from "../RefreshButton";
import ArchiveButton from "../View/ArchiveButton";
import { DiiaIcon } from "../../../public/icons";
import DeleteButton from "../docActions/DeleteButton";
import { DeleteConfirmModal, NotReadyToSignModal } from "../Popup/ConfirmModal";
import { useDeleteDocs } from "../../hooks/useDeleteDocs";
// import { Edit } from "../icons";

export default function DocsToolbar(props: any) {

  const deleteDocState = useAppSelector((state)=> state.deleteDoc);
  const docs = useAppSelector((state) => state.docs);
    const user = useAppSelector((state) => state.user);
  
  const { initiateDelete, showConfirmModal, docsToDeleteTitles, confirmDelete, cancelDelete, checkAllDocsDeletable} =
  useDeleteDocs(user, { navigateBack: false,  onSuccess: 
   props.docsUpdate });

  const disabled = props.doc && isDocDisabled(props.doc);
  const isDiiaEnabled = process.env.DIIA_ENABLED === 'true';
  const checkDocs = !checkAllDocsDeletable(props.selectedDocs);

  const [invalidDocs, setInvalidDocs] = useState<string[]>([]);
  const docsList = useAppSelector((state) => (state as any).docs?.list ?? []);

  const withValidation = (handler: ((...args: any[]) => void) | null | undefined) => {
    if (!handler) return undefined;
    return (...args: any[]) => {
      if (props.doc) {
        if (!isDocReadyToSign(props.doc)) {
          props.onOpenAttrPopup?.();
          return;
        }
        handler(...args);
        return;
      }
      if (props.selectedDocs?.length) {
        const invalid = docsList.filter(
          (doc: any) => props.selectedDocs.includes(doc.id) && !isDocReadyToSign(doc),
        );
        if (invalid.length > 0) {
          setInvalidDocs(invalid.map((d: any) => d.title || d.id));
          return;
        }
      }
      handler(...args);
    };
  };

 return (
  <>
    <Bar>
      <MediaQuery maxWidth={767}>
        <label className={`${styles.check} ${styles.mobile_spreadsheet} `}>
          <input
            type="checkbox"
            onChange={(e) => props.toggleAll(e.target.checked)}
            ref={(input) => {
              if (input) {
                const selected = Object.values(
                  props.docs?.selected || {},
                ).filter((el) => !!el).length;
                const active = props.docs?.list.filter(
                  (el: { cancelled: boolean }) => !el.cancelled,
                ).length;
                if (selected > 0) {
                  input.indeterminate = selected !== active;
                  input.checked = selected === active;
                } else {
                  input.checked = input.indeterminate = false;
                }
              }
            }}
          />
          <span className={styles.checkmark}></span>
        </label>
      </MediaQuery>

      <div style={{ display: "flex", gap: "10px" }}>
        <RefreshButton
          docsUpdate={props.docsUpdate}
          disabled={docs.state === "loading"}
        />
        {!props.hideDownloadFilesBtn && (
          <DownloadButton
            selectedDocs={props.selectedDocs}
            token={props.token}
            type={props.type}
            bgColor="var(--sidebar-hover)"
            $color="var(--blue)"
          />
        )}
        {(!props.doc || canArchiveDoc(props.doc, user.id)) && (
          <ArchiveButton
            docsUpdate={props.docsUpdate}
            selectedDocs={props.selectedDocs}
            doc={props.doc}
            archived={props.isArchived}
          />
        )}
        
        <DeleteButton
          disable={props.selectedDocs.length === 0 || checkDocs}
          onClick={() => initiateDelete(props.selectedDocs)}
          error={deleteDocState.state === "failure" && deleteDocState.result.message}
          state={deleteDocState.state}
        />

        {/* <AlertTooltip title="Наазначення атрибутів">
          <BtnWrapper
            disabled={props.selectedDocs.length === 0}
            $bgColor="var(--sidebar-hover)"
            onClick={props.editAttribute}
          >
            <Edit color={props.selectedDocs.length === 0 ? "var(--disabled-c)" :"var(--blue)"} />
          </BtnWrapper>
        </AlertTooltip> */}
      </div>

      {invalidDocs.length > 0 && (
        <NotReadyToSignModal docs={invalidDocs} onClose={() => setInvalidDocs([])} />
      )}
      <ListForSign>
        <MediaQuery minWidth={768}>
          {isDiiaEnabled && (
            <li>
              <Btn
                $background="var(--black)"
                type="button"
                $fontS="14px"
                onClick={withValidation(props.clickDiiaSignButton)}
                disabled={!props.clickDiiaSignButton || disabled}
                style={{display:"flex", gap:"8px"}}
              >
                <DiiaIcon color={!props.clickDiiaSignButton || disabled ? "var(--disabled-btn-bg)": "black"}/>
               <div>Підпис</div>
              </Btn>
            </li>
          )}
          <li>
            <Btn
              $background="var(--orange)"
              type="button"
              $fontS="14px"
              onClick={withValidation(props.clickStampButton ?? props.clickFileSignButton)}
              disabled={!(props.clickStampButton ?? props.clickFileSignButton) || disabled}
            >
              {props.clickStampButton ? "Додати печатку" : "Підпис КЕП"}
            </Btn>
          </li>
          <li>
            <Btn
              $background="var(--blue)"
              type="button"
              $fontS="14px"
              onClick={withValidation(props.clickSignButton)}
              disabled={!props.clickSignButton || disabled}
            >
              Підпис Гряда
            </Btn>
          </li>
        </MediaQuery>
      </ListForSign>
    </Bar>
    {showConfirmModal ? <DeleteConfirmModal onConfirm={confirmDelete} docs={docsToDeleteTitles} onClose={cancelDelete}/>: null}
  
  </>

  );
}
